/**
 * Seção numerada do assistente — o mesmo desenho dos cartões da Nova Despesa
 * (feature não importa de feature, então o visual é repetido aqui).
 */
export default function Cartao({ numero, titulo, descricao, icone: Icone, children, e2e }) {
  return (
    <section className="bg-card rounded-2xl border p-5 sm:p-6" data-e2e={e2e}>
      <div className="flex items-start gap-3 mb-4">
        {numero != null && (
          <span className="w-7 h-7 rounded-full bg-primary/10 text-primary text-sm font-bold flex items-center justify-center shrink-0">{numero}</span>
        )}
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-bold leading-tight flex items-center gap-2">
            {Icone && <Icone className="w-4 h-4 text-primary shrink-0" />}{titulo}
          </h2>
          {descricao && <p className="text-xs text-muted-foreground mt-0.5">{descricao}</p>}
        </div>
      </div>
      {children}
    </section>
  );
}
